var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPulseTitleLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.333 51.2002V13.8669H34.6663V51.2002H29.333ZM18.6663 43.2002V21.8669H23.9997V43.2002H18.6663ZM39.9997 43.2002V21.8669H45.333V43.2002H39.9997ZM7.99967 35.2002V29.8669H13.333V35.2002H7.99967ZM50.6663 35.2002V29.8669H55.9997V35.2002H50.6663Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPulseTitleLogo);
export default __webpack_public_path__ + "static/media/pulse-title-logo.a1720ae1c8b8f91d6c7ba12dbb728e09.svg";
export { ForwardRef as ReactComponent };